import Api from '../../Api';

interface IFeatureFeedback {
  feature: string;
  rating: string;
  text: string;
  usedToOptIn: boolean;
  usedToOptOut: boolean;
  canBeContacted: boolean;
}

const FeatureFeedbackService = {
  createFeatureFeedback: async (request: IFeatureFeedback) => {
    await Api.post(`feedback/feature`, request);
  },
};

export default FeatureFeedbackService;
